import './OpenPageSection.scss';
import { Link } from 'react-router-dom';

function OpenPageSection({ text, btnText, btnLink, backgroundColor }) {
  // Verifica se a cor de fundo é a cor específica
  const isRedBackground = backgroundColor === '#B32929';

  return (
    <div 
      id='section-holder' 
      // Mantém o fundo dinâmico e adiciona a classe condicional se for verdadeiro
      className={isRedBackground ? 'is-red' : ''} 
      style={{ backgroundColor: backgroundColor }}
    >
        <h2>{text}</h2>
        <Link to={btnLink}>
          <button>{btnText}</button>
        </Link>
    </div>
  );
}

export default OpenPageSection;